import request from '@/utils/request'

//获取banner
export function homeBanner(url, data) {
    return request({
        method: 'post',
        url,
        data,
    });

}

//获取新闻分类
export function getNewsType(url) {
    return request({
        method: 'post',
        url
    })
}

//获取新闻列表
export function Getnews(url, data) {
    return request({
        method: 'post',
        url,
        data,
    })
}

//获取新闻详情
export function getNewsDetails(url, data) {
    return request({
        method: 'post',
        url,
        data,
    })
}

//获取核心团队
export function getcoreteam(url, data) {
    return request({
        method: 'post',
        url,
        data,
    })
}

//获取课程体系
export function getcourses(url, data) {
    return request({
        method: 'post',
        url,
        data,
    })
}

//获取教育服务
export function geteducationalServices(url) {
    return request({
        method: 'post',
        url
    })
}

//提交联系我们
export function submitContactUs(url, data) {
    return request({
        method: 'post',
        url,
        data
    })
}

//获取课程分类
export function getCourseType(url) {
    return request({
        method: 'post',
        url
    })
}

export function proxy(url) {
    return request({
        method: 'get',
        url
    })
}

export function aboutUsContent(url) {
    return request({
        method: 'post',
        url
    })
}
export function obtainJobType(url) {
    return request({
        method: 'post',
        url
    })
}
export function obtainJobInformation(url, data) {
    return request({
        method: 'post',
        url,
        data
    })
}
export function jobDetails(url, data) {
    return request({
        method: 'post',
        url,
        data
    })
}
export function businessSegment(url, data) {
    return request({
        method: 'post',
        url,
        data
    })
}
export function businessSegmentDetails(url, data) {
    return request({
        method: 'post',
        url,
        data
    })
}
export function changeBrowsingFrequency(url, data) {
    return request({
        method: 'post',
        url,
        data
    })
}